import { render } from "./Movie.vue?vue&type=template&id=3f00b2ec"
import script from "./Movie.vue?vue&type=script&lang=js"
export * from "./Movie.vue?vue&type=script&lang=js"
script.render = render

export default script